import Flickity from "flickity";

class NewsCarousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carouselElem = self.elem.querySelector('[data-carousel]');
        self.cards = self.elem.querySelectorAll('.card');
    }

    init() {
        let self = this;

        self.getCarousel();
    }

    getCarousel() {
        let self = this;

        const flkty = new Flickity(self.carouselElem, {
            cellAlign: 'left',
            contain: true,
            draggable: true,
            wrapAround: true
        });
    }
}

export default NewsCarousel;
